import ConversationItem from 'models/conversation_item';

export default class ActiveSecureDataRequestsObserver {
  constructor(context) {
    this.context = context;
  }

  onBroadcast(activeSecureDataRequestDto, { customerId }) {
    const customerStores = this.context.stores.customers.storesFor(customerId);
    const activeSecureDataRequestsStore = customerStores.activeSecureDataRequests;
    const activeSecureDataRequest = ConversationItem.fromJs(activeSecureDataRequestDto);

    activeSecureDataRequest.content.isActive()
      ? activeSecureDataRequestsStore.addOrReplace(activeSecureDataRequest)
      : activeSecureDataRequestsStore.remove(activeSecureDataRequest.id);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/customer/active_secure_data_requests_observer.js